/**
 * @vuepress
 * ---
 * title: Permissions
 * ---
 */

import { mapGetters, mapState } from 'vuex'
import store from '@/store'

const permissionsMixin = {
  computed: {
    ...mapState({ $account: 'account' }),
    ...mapGetters('account', {
      '$modelPermission': 'modelPermission',
      '$can': 'userAccountCan',
      '$canAdd': 'userAccountCanAdd',
      '$canChange': 'userAccountCanChange',
      '$canView': 'userAccountCanView',
      '$canDelete': 'userAccountCanDelete',
      '$isAdmin': 'userAccountIsAdmin',
      '$inGroup': 'userAccountInGroup'
    })
  }
}

const commentNode = (el, vnode, hide = true) => {
  el.style.display = hide ? 'none' : 'block'
}

const permissionsDirective = (checkHasPermission = true, separator = '\\') =>
  (el, bindings, vnode) => {
    const { arg: permission, modifiers: appsModels } = bindings
    Object.entries(appsModels).forEach(([appModel]) => {
      const [app, model] = appModel.split(separator)
      
      const hasPermission = store.getters['account/userCan'](
        permission, app, model
      )

      if (checkHasPermission ? !hasPermission : hasPermission) {
        commentNode(el, vnode)
      }
    })
  }

export default {
  install(Vue) {
    Vue.mixin(permissionsMixin)
    Vue.directive('can', permissionsDirective(true))
    Vue.directive('cant', permissionsDirective(false))
  }
}



// WEBPACK FOOTER //
// ./src/plugins/accountPermissions/permissionsMixin.js